<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Loading overlay -->
    <LoadingOverlay v-if="isLoading" />
    
    <!-- Main app content -->
    <router-view />
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import LoadingOverlay from '@/components/ui/LoadingOverlay.vue'

const authStore = useAuthStore()
const appStore = useAppStore()

const isLoading = computed(() => appStore.isLoading)

onMounted(async () => {
  // Initialize auth state from localStorage
  const token = localStorage.getItem('auth_token')
  if (token) {
    try {
      await authStore.fetchUser()
    } catch (error) {
      console.error('Failed to fetch user:', error)
      authStore.logout()
    }
  }
})
</script>

<style>
/* Global styles are in app.css */
</style>